import { Injectable } from '@angular/core';

import { ignoreElementsTyped } from '@frontend/sports/common/core/utils/rxjs';
import { BetslipNotificationRequest, PlaceBetStatus } from '@frontend/sports/types/betslip';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, mergeMap } from 'rxjs';

import NotificationService from '../../settings/services/notification.service';
import { BetslipPlaceBetActions } from '../actions';
import { ISucceededPartialSlipResult, ISucceededSlipResult } from '../models';
import PlaceBetService from '../services/place-bet.service';
import { isSucceededSlip } from '../utils';

@Injectable()
export default class NotificationEffects {
    constructor(
        private actions$: Actions,
        private placeBetService: PlaceBetService,
        private notificationService: NotificationService,
    ) {}

    handleFinishPlaceBet$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(BetslipPlaceBetActions.finishPlaceBet),
            concatMap((action) => {
                const picks = Object.values(action.requestPicks.picks);
                const notificationStatus = {
                    isAppNotificationEnabled: action.state.settings.notifications.appNotify,
                    isEmailNotificationEnabled: action.state.settings.notifications.emailNotify,
                };
                const notificationSettings = this.notificationService.notificationStatus(picks, notificationStatus);
                const shouldNotify = notificationSettings.isAppNotificationEnabled || notificationSettings.isEmailNotificationEnabled;

                if (action.placeBetResult.status === PlaceBetStatus.Success && shouldNotify) {
                    const request: BetslipNotificationRequest = {
                        betNumbers: action.placeBetResult.slips
                            .filter(isSucceededSlip)
                            .map((s: ISucceededSlipResult | ISucceededPartialSlipResult) => s.betNumber),
                        appNotify: notificationSettings.isAppNotificationEnabled,
                        emailNotify: notificationSettings.isEmailNotificationEnabled,
                    };

                    return [BetslipPlaceBetActions.setNotification({ request })];
                }

                return [];
            }),
        );
    });

    handleSetNotification$ = createEffect(
        () => {
            return this.actions$.pipe(
                ofType(BetslipPlaceBetActions.setNotification),
                mergeMap((action) => this.placeBetService.setNotification(action.request)),
                ignoreElementsTyped(),
            );
        },
        { dispatch: false },
    );
}
